import { AxiosResponse } from 'axios';

export const data = <T>(res: Promise<AxiosResponse<T>>): Promise<T> =>
    res.then(({ data }) => data);
